import { CommonButton } from 'components/Buttons';
import { Header } from 'components/Modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import styled from 'styled-components/macro';
import utils from 'utils';

export const ButtonContainer = styled.div`
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  button {
    margin: 10px;
  }
`;

const ValidationConfirmModal = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const modalProps = useSelector(selectors.modal.getModalProps) as {
    title?: string;
    subTitle: string;
    onConfirm: () => void;
  };

  const { title, subTitle, onConfirm } = modalProps;

  return (
    <>
      <Header title={t(title || 'sure_want_proceed')} subtitle={t(subTitle)} />
      <ButtonContainer>
        <CommonButton id="confirm-btn" scope="primary" value={t('continua')} action={onConfirm} />
        <CommonButton
          id="cancel-btn"
          scope="secondary"
          value={t('annulla')}
          action={() => dispatch(actions.modal.closeModal())}
        />
      </ButtonContainer>
    </>
  );
};

export default ValidationConfirmModal;
